"use client" 
import Loading from "@/components/Atoms/Alerts/Loading";
import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import { useState, useEffect } from "react";
import SupportModal from "../Modals/SupportModal";

const UserWorkspaceSideNavbar =({callback, lang, user, mainNavbarVisible, appNotificationsArr =[], chatNotificationsArr =[]}) => {
  
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const search = searchParams.get('url')
  const [url, setUrl] = useState({})
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [hovering, setHovering] = useState(false)
  const [sideNavbarPinned, setSideNavbarPinned] = useState(false)
  const [sideNavbarHovering, setSideNavbarHovering] = useState(false)
  const [supportModalOpen, setSupportModalOpen] = useState(false)
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)
  // const [loading, state.setLoading] = useState(false)
  const [currentNavId, setCurrentNavId] = useState(null)


    const unreadAppNotifications = appNotificationsArr.filter(n => n.notification_status === 'INIT')
    const unreadChatNotifications = chatNotificationsArr.filter(n => n.notification_status === 'INIT')

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);

  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  useEffect(() => {

    setCurrentNavId( window.location.href.endsWith('/workspace') ? 1 : window.location.href.endsWith('/workspace/jobs') ? 4 : window.location.href.endsWith('/workspace/talent') ? 3 : window.location.href.endsWith('/workspace/settings') ? 10 : 0)

    // state.setLoading(false)
    // Attach a click event listener to the document
    document.addEventListener("click", closeDropdown);

    setUrl({
      pathname: window.location.pathname.split(`/`)[1] || '',
      search: window.location.search
      });

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", closeDropdown);
    };
  }, []);

  const handleDropdownClick = (e) => {
    // Prevent the click on the dropdown itself from triggering the closeDropdown
    e.stopPropagation();
  };

  const handleToggleClick = (e) => {
    e.stopPropagation();
    toggleDropdown();

  };

     return (
          
      <aside
      // onMouseEnter={() => setHovering(true)}
      // onMouseLeave={() => setHovering(false)}
      onMouseEnter={() => {setSideNavbarHovering(true); callback({ sideNavbarHovering: true })}}
      onMouseLeave={() => {setSideNavbarHovering(false); callback({ sideNavbarHovering: false })}}
      id="NavSidebar"
      className={`fixed ${mainNavbarVisible ? 'top-16 h-[94vh]' : 'top-0 h-screen'} left-0 z-30 ${(sideNavbarHovering || sideNavbarPinned) ? 'w-60' : 'w-12 md:w-20'} duration-300 overflow-scroll bg-slate-50 border-r border-slate-200 sm:translate-x-0 dark:bg-slate-800 dark:border-slate-700 dark:bg-slate-900 text-xl no-scrollbar font-ubuntu`}
      aria-label="NavSidebar"
    >

      {/* {loading && <Loading lang={lang}/>} */}
      {/* bg-gradient-to-t from-violet-700 via-violet-600 to-indigo-600  */}
      <div className="h-full bg-slate-50 dark:bg-slate-900 flex flex-col justify-between">
      {/* <div className="mx-auto pt-2 text-sm text-black dark:text-white dark:hover:text-slate-500 hover:text-slate-600 duration-300"> */}
<div className="mt-2">
      {/* <Link href={`employers/`}
              className={`transition duration-300 ease-in-out text-black dark:text-slate-200 flex text-xs leading-snug hover:bg-slate-200 dark:hover:bg-slate-800 py-2`}>
              <span className="text-center mx-auto"><i className="fa-solid fa-binoculars items-center text-xl"></i><br/>
              {lang === 'fr' ? 'Votre Page' : 'Your Page'}</span>
            </Link>
 */}

      
         {/* <i class="fa-solid fa-thumbtack"></i> */}
         <Link 
         onClick={()=>{
          setSideNavbarPinned(!sideNavbarPinned); 
          callback({ sideNavbarPinned: !sideNavbarPinned })
        }}
  href={``}
  className="px-2.5 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
  <i className={`min-w-4 md:min-w-6 fa-solid ${sideNavbarPinned ? 'fa-bars' : 'fa-bars-staggered'} mr-2`}></i>
  <span className={`text-sm ${(sideNavbarHovering || sideNavbarPinned) ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{sideNavbarPinned ? 'Unpin Navbar' : 'Pin Navbar'}</span>
</Link>

     <Link 
        // onClick={()=>{state.setSupportModalOpen(true)}}
        onClick={()=>{callback({notificationsModalOpen:true})}}
        href={`#`}
  className="px-2.5 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center  hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
    {/* <div className="text-xs bg-white rounded-full -mr-3 z-10 w-4 h-4">32</div> */}
  <i className={`min-w-5 md:min-w-6 ${unreadAppNotifications.length > 0 ? 'fa-solid text-teal-400' : 'fa-regular'} fa-bell mr-2`}></i>
  {/* {hovering && <span className="delay-500 duration-500">{lang === 'fr' ? 'English' : 'Français'}</span>} */}
  <span className={`text-sm ${(sideNavbarHovering || sideNavbarPinned) ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{lang === 'fr' ? 'Notifications' : `${unreadAppNotifications.length} Notification(s)`}</span>
</Link>




     <Link 
            //  onClick={()=>{callback({chatNotificationsModalOpen:true})}}
        // onClick={()=>{state.setSupportModalOpen(true)}}
        // onClick={()=>{callback({notificationsModalOpen:true})}}
        href={`/workspace/chat`}
  className="px-2.5 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center  hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
    {/* <div className="text-xs bg-white rounded-full -mr-3 z-10 w-4 h-4">32</div> */}
<i className={`min-w-5 md:min-w-6 ${unreadChatNotifications.length > 0 ? 'fa-solid text-teal-400' : 'fa-regular'} fa-envelope mr-2`}></i>
  {/* <i className={`min-w-5 md:min-w-6 fa-regular fa-envelope mr-2`}></i> */}
  {/* {hovering && <span className="delay-500 duration-500">{lang === 'fr' ? 'English' : 'Français'}</span>} */}
  {/* <span className={`text-sm ${(hovering || sideNavbarPinned) ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{lang === 'fr' ? 'Chats' : `${unreadNotifications.length} Chat(s)`}</span> */}
    <span className={`text-sm ${(sideNavbarHovering || sideNavbarPinned) ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{lang === 'fr' ? 'Messages' : `${unreadChatNotifications.length} Message(s)`}</span>
    {/* <span className={`text-sm ${(sideNavbarHovering || sideNavbarPinned) ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{lang === 'fr' ? 'Chats' : `Chat`}</span> */}
</Link>



{/* <Link 
  href={`/${lang === 'fr' ? `en/${url.pathname}${url.search}` : `fr/${url.pathname}${url.search}`}`}
  className="px-2.5 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
  <i className="min-w-4 md:min-w-6 fa-solid fa-globe text-xl mr-2"></i>
  <span className={`${hovering ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{lang === 'fr' ? 'English' : 'Français'}</span>
</Link> */}

</div>





<div className="text-black dark:text-slate-200 space-y-1">




            <Link 
              onClick={()=>{setCurrentNavId(1); }}
              href={`/workspace`}
  className="px-2.5 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
  <i className="min-w-5 md:min-w-6 fa-regular fa-clipboard mr-2"></i>
  <span className={`text-sm ${(sideNavbarHovering || sideNavbarPinned) ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300 font-ubuntu`}>{lang === 'fr' ? 'Console' : 'Dashboard'}</span>
</Link>
 

{user.user_type !== 'EMPLOYER' &&      <Link 
            onClick={()=>{setCurrentNavId(3); }}
            href={`/workspace/talent`}
  className="px-2.5 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
  <i className="min-w-5 md:min-w-6 fa-regular fa-address-book mr-2"></i>
  {/* {hovering && <span className="delay-500 duration-500">{lang === 'fr' ? 'English' : 'Français'}</span>} */}
  <span className={`text-sm ${(sideNavbarHovering || sideNavbarPinned) ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{lang === 'fr' ? 'Vos Talents' : 'Your Talents'}</span>
</Link>}



<Link 
              onClick={()=>{setCurrentNavId(4); }}
              href={`/workspace/jobs`}
  className="px-2.5 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
  <i className="min-w-5 md:min-w-6 fa-regular fa-folder-closed mr-2"></i>
  {/* {hovering && <span className="delay-500 duration-500">{lang === 'fr' ? 'English' : 'Français'}</span>} */}
  <span className={`text-sm ${(sideNavbarHovering || sideNavbarPinned) ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{lang === 'fr' ? 'Vos Offres' : 'Your Jobs'}</span>
</Link>

<Link 
              onClick={()=>{setCurrentNavId(5); }}
              href={`/workspace/submissions`}
  className="px-2.5 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
  <i className="min-w-5 md:min-w-6 fa-regular fa-address-card mr-2"></i>
  {/* {hovering && <span className="delay-500 duration-500">{lang === 'fr' ? 'English' : 'Français'}</span>} */}
  <span className={`text-sm ${(sideNavbarHovering || sideNavbarPinned) ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{lang === 'fr' ? 'Vos Soumissions' : 'Your Submissions'}</span>
</Link>


<Link 
      onClick={()=>{setCurrentNavId(6); }}
              href={`/workspace/organizations`}
  className="px-2.5 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
  <i className="min-w-5 md:min-w-6 fa-regular fa-house mr-2"></i>
  {/* {hovering && <span className="delay-500 duration-500">{lang === 'fr' ? 'English' : 'Français'}</span>} */}
  <span className={`text-sm ${(sideNavbarHovering || sideNavbarPinned) ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{lang === 'fr' ? 'Vos Organizations' : 'Your Organizations'}</span>
</Link>



{/* <Link 
             onClick={()=>{setCurrentNavId(5); }}
             href={`/workspace/campaigns`}
  className="px-2.5 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center text-xs leading-snug hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
  <i className="min-w-4 md:min-w-6 fa-solid fa-bullhorn text-xl mr-2"></i>
  <span className={`${hovering ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{lang === 'fr' ? 'Vos Campagnes' : 'Your Campaigns'}</span>
</Link> */}




            <div className="text-gray-500 justify-center flex py-3">
            <hr className="w-1/2"/>
            </div>

{/* {console.log('user@nav', user)} */}

         {user.user_type === 'ROOT' && <Link 
              onClick={()=>{}}
              href={`/admin/organizations`}
  className="px-2 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
                <i className="fa-solid fa-shop min-w-5 md:min-w-6 items-center mr-2"></i><br/>
  {/* {hovering && <span className="delay-500 duration-500">{lang === 'fr' ? 'English' : 'Français'}</span>} */}
  <span className={`text-sm ${(sideNavbarHovering || sideNavbarPinned) ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{lang === 'fr' ? 'Organizations' : 'Organizations'}</span>
</Link>
}

         {user.user_type === 'ROOT' && <Link 
              onClick={()=>{}}
              href={`/admin/users`}
  className="px-2 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
   <i className="fa-solid fa-users min-w-3 md:min-w-6 items-center mr-2"></i><br/>
  {/* {hovering && <span className="delay-500 duration-500">{lang === 'fr' ? 'English' : 'Français'}</span>} */}
  <span className={`text-sm ${(sideNavbarHovering || sideNavbarPinned) ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{lang === 'fr' ? 'Usagers' : 'Users'}</span>
</Link>
}

         {user.user_type === 'ROOT' && <Link 
              onClick={()=>{}}
              href={`/admin/logs`}
  className="px-2 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
                <i className="fa-solid fa-list min-w-5 md:min-w-6 items-center mr-2"></i><br/>
  {/* {hovering && <span className="delay-500 duration-500">{lang === 'fr' ? 'English' : 'Français'}</span>} */}
  <span className={`text-sm ${(sideNavbarHovering || sideNavbarPinned) ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{lang === 'fr' ? 'Logs' : 'Logs'}</span>
</Link>
}

{user.user_type === 'ROOT' && <Link 
              onClick={()=>{}}
              href={`/admin/tags`}
  className="px-2 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
   <i className="fa-solid fa-tag min-w-5 md:min-w-6 items-center mr-2"></i><br/>
  {/* {hovering && <span className="delay-500 duration-500">{lang === 'fr' ? 'English' : 'Français'}</span>} */}
  <span className={`text-sm ${(sideNavbarHovering || sideNavbarPinned) ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{lang === 'fr' ? 'Tags' : 'Tags'}</span>
</Link>
}

{user.user_type === 'ROOT' && <Link 
              onClick={()=>{}}
              href={`/admin/topics`}
  className="px-2 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
   <i className="fa-solid fa-tag min-w-5 md:min-w-6 items-center mr-2"></i><br/>
  {/* {hovering && <span className="delay-500 duration-500">{lang === 'fr' ? 'English' : 'Français'}</span>} */}
  <span className={`text-sm ${(sideNavbarHovering || sideNavbarPinned) ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{'Topics'}</span>
</Link>
}

{user.user_type === 'ROOT' && <Link 
              onClick={()=>{}}
              href={`/admin/moderation`}
  className="px-2 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
   <i className="fa-solid fa-gavel min-w-5 md:min-w-6 items-center mr-2"></i><br/>
  {/* {hovering && <span className="delay-500 duration-500">{lang === 'fr' ? 'English' : 'Français'}</span>} */}
  <span className={`text-sm ${(sideNavbarHovering || sideNavbarPinned) ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{'Moderation'}</span>
</Link>
}

            {/* <Link 
              href="#" 
              onClick={()=>{callback({talentModalOpen:true})}}
  className="px-2.5 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center text-xs leading-snug hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
  <i className="min-w-4 md:min-w-6 fa-solid fa-person-circle-plus text-xl mr-2"></i>
  <span className={`${hovering ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{lang === 'fr' ? 'Publier Talent' : 'Publish Talent'}</span>
</Link> */}


{/* <Link 
              href="#" 
              onClick={()=>{callback({talentModalOpen:true})}}
  className="px-2.5 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center text-xs leading-snug hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
  <i className="min-w-4 md:min-w-6 fa-solid fa-file-circle-plus text-xl mr-2"></i>
  <span className={`${hovering ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{lang === 'fr' ? 'Publier Offre' : 'Publish Job'}</span>
</Link> */}


{/* <Link 
              href="#" 
              onClick={()=>{callback({campaignModalOpen:true})}}
  className="px-2.5 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center text-xs leading-snug hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
  <i className="min-w-4 md:min-w-6 fa-solid fa-folder-plus text-xl mr-2"></i>
  <span className={`${hovering ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{lang === 'fr' ? 'Nouvelle Campagne' : 'New Campaign'}</span>
</Link> */}


{/* fa-solid fa-user-plus */}



</div>



          
       


        {/* BOTTOM */}
        <div className="text-black dark:text-slate-200 mb-2">



<div className="">
      <Link 
        // onClick={()=>{state.setSupportModalOpen(true)}}
        onClick={()=>{callback({supportModalOpen:true})}}
        href={`#`}
  className="px-2.5 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center  hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
  <i className="min-w-5 md:min-w-6 fa-regular fa-comment mr-2"></i>
  {/* {hovering && <span className="delay-500 duration-500">{lang === 'fr' ? 'English' : 'Français'}</span>} */}
  <span className={`text-sm ${(sideNavbarHovering || sideNavbarPinned) ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{lang === 'fr' ? 'Support' : 'Support'}</span>
</Link>


{user.user_type === 'ROOT' && <Link 
        onClick={()=>{ }}
        href={`/admin/root`}
  className="px-2.5 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center  hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
  <i className="min-w-5 md:min-w-6 fa-solid fa-gear mr-2"></i>
  {/* {hovering && <span className="delay-500 duration-500">{lang === 'fr' ? 'English' : 'Français'}</span>} */}
  <span className={`text-sm ${(sideNavbarHovering || sideNavbarPinned) ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{lang === 'fr' ? 'Root' : 'Root'}</span>
</Link>}

<Link 
        onClick={()=>{setCurrentNavId(10); }}
        href={`/workspace/settings`}
  className="px-2.5 md:pl-6 transition duration-100 ease-in-out text-black dark:text-slate-200 flex items-center  hover:bg-slate-200 dark:hover:bg-slate-800 py-4 mx-1 rounded text-center">
  <i className="min-w-5 md:min-w-6 fa-solid fa-gear mr-2"></i>
  {/* {hovering && <span className="delay-500 duration-500">{lang === 'fr' ? 'English' : 'Français'}</span>} */}
  <span className={`text-sm ${(sideNavbarHovering || sideNavbarPinned) ? 'translate-x-0' : '-translate-x-96'} duration-100 whitespace-nowrap delay-100 duration-300`}>{lang === 'fr' ? 'Réglages' : 'Settings'}</span>
</Link>

</div>

      



        {/* <Link 
          href="/admin/root"
          className="transition delay-10 duration-300 ease-in-out block bg-slate-200 dark:bg-slate-700 hover:bg-slate-300 dark:hover:bg-slate-600 text-slate-700 text-2xl rounded-lg m-1 dark:text-slate-200"
        >
          <li className="flex justify-center items-center py-2">
            <i className="fa-solid fa-cog"></i>
          </li>
        </Link> */}
</div>
        
      </div>
    </aside>

     )
}

export default UserWorkspaceSideNavbar